export enum TeamRole {
  hiringManager = 'Hiring manager',
  recruitingManager = 'Recruiting manager',
  regularRecruiter = 'Recruiter',
  coordinator = 'Coordinator'
}

export const TEAM_ROLES = [
  TeamRole.hiringManager,
  TeamRole.recruitingManager,
  TeamRole.regularRecruiter,
  TeamRole.coordinator
];

export const MapPluralToSingular = {
  regularRecruiters: TeamRole.regularRecruiter,
  recruitingManagers: TeamRole.recruitingManager,
  hiringManagers: TeamRole.hiringManager,
  coordinators: TeamRole.coordinator
};
